export const formatFieldName = (name: string) => {
  if (!name) return "";
  const spaced = name.replace(/([A-Z])/g, " $1");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};